import {createFileRoute} from '@tanstack/react-router';
import {CustomerTabPage} from '../../../../features/settings/pages/CustomerTabPage/CustomerTabPage';

export const Route = createFileRoute('/_protected/home/service/')({
  component: CustomerTabPage,
});
